import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const STORAGE_KEY = 'baruk.go.lastScreen';

const IGNORED_PATHS = ['/access-denied', '/login', '/forgot-password', '/reset-password'];

export function rememberLastScreen(pathname: string, search: string): void {
  if (IGNORED_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`))) {
    return;
  }

  const target = `${pathname}${search}`;
  try {
    sessionStorage.setItem(STORAGE_KEY, target);
  } catch {
    // Sessão indisponível: o botão cai no início.
  }
}

export function readLastScreen(): string | null {
  try {
    const value = sessionStorage.getItem(STORAGE_KEY)?.trim();
    if (!value || value === '/access-denied' || value.startsWith('/access-denied?')) {
      return null;
    }
    return value;
  } catch {
    return null;
  }
}

export function isRestoreLastScreen(state: unknown): boolean {
  return Boolean(
    state
    && typeof state === 'object'
    && 'restoreLastScreen' in state
    && (state as { restoreLastScreen?: boolean }).restoreLastScreen,
  );
}

export function useRememberLastScreen(): void {
  const location = useLocation();

  useEffect(() => {
    rememberLastScreen(location.pathname, location.search);
  }, [location.pathname, location.search]);
}
